import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import { queryKeys } from '../api/keys';
import { recordConsent } from '../api/mutations';
import { accountQueryOptions } from '../api/queries';
import { takePendingConsent } from '../lib/consent';

// The web app asks before it shows anything: a box ticked at sign-up or before Strava is recorded here, and anyone
// else (an account from before consent) goes to the one-time consent screen. An API from before consent sends no
// consentedAt (undefined) and has nowhere to record it, so nobody is gated mid-deploy.
export async function ensureConsent(queryClient: QueryClient): Promise<void> {
  const pending = takePendingConsent();
  const account = await queryClient.ensureQueryData(accountQueryOptions());
  if (account.consentedAt !== null) return;
  if (!pending) throw redirect({ to: '/consent' });
  await recordConsent();
  // Refetched, not just invalidated: later navigations read the cached account, and nothing observes it here.
  await queryClient.refetchQueries({ queryKey: queryKeys.account });
}
